export const UserFieldsTemplates = {
  'app/components/user-fields/form.discrete.html': require('./form.discrete.html').default,
  'app/components/user-fields/form.file.html': require('./form.file.html').default
  // 'user-field-hierarchy.html': require('user-field-hierarchy.html').default
};
